import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment-timezone'

import { cloneGallery } from '@/lib/utils'

import submitPlatformPost from '@/graphql/mutations/submissions/submitPlatformPost.gql'
import reschedulePlatformPost from '@/graphql/mutations/submissions/reschedulePlatformPost.gql'
import removeSubmissionFromPlatform from '@/graphql/mutations/submissions/removeSubmissionFromPlatform.gql'
import deletePlatformPost from '@/graphql/mutations/submissions/deletePlatformPost.gql'
import duplicatePlatformPost from '@/graphql/mutations/submissions/duplicatePlatformPost.gql'

import allYouTubeSubmissions from '@/graphql/queries/youtube/allYouTubeSubmissions.gql'
import youtubePost from '@/graphql/queries/youtube/youtubePost.gql'

export default {
  code: 'youtube',
  name: 'YouTube',
  icon: 'youtube',
  color: '#FF0000',
  accountNoun: 'Channel',
  postNoun: 'Short',
  internalPostNoun: 'YouTubePost',
  mutations: {
    submitPost: submitPlatformPost,
    submitPostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    deletePost: deletePlatformPost,
    deletePostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    reschedulePost: reschedulePlatformPost,
    reschedulePostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    duplicatePost: duplicatePlatformPost,
    removeSubmissionFromPlatformMutation: removeSubmissionFromPlatform
  },
  queries: {
    allSubmissions: allYouTubeSubmissions,
    getPost: youtubePost
  },
  posts: {
    preparePostForScheduling: (post, publishingStatus = 'READY_TO_PUBLISH') => {
      let clonedGallery = cloneDeep(post.gallery)
      let gallery = null
      if (clonedGallery) {
        gallery = {
          id: clonedGallery.id,
          galleryMediaSet: []
        }
        gallery.galleryMediaSet = clonedGallery.galleryMediaSet.map(
          (mediaSet) => {
            return {
              id: mediaSet.id,
              order: mediaSet.order,
              media: {
                name: mediaSet.media.name,
                url: mediaSet.media.url,
                externalId: mediaSet.media.externalId,
                mimeType: mediaSet.media.mimeType,
                size: mediaSet.media.size,
                source: mediaSet.media.source
              }
            }
          }
        )
      }

      let submissions = post.submissions.map((submission) => {
        return {
          id: submission.id,
          postAt: submission.postAt
        }
      })

      return {
        id: post.id,
        username: post.username,
        gallery,
        title: post.title,
        description: post.description,
        tags: post.tags,
        madeForKids: post.madeForKids,
        privacyStatus: post.privacyStatus,
        submissions,
        publishingStatus
      }
    },
    createPost(socialAccount) {
      return {
        id: null,
        username: socialAccount.username,
        title: '',
        description: '',
        tags: [],
        madeForKids: false,
        privacyStatus: 'PUBLIC',
        publishingStatus: 'READY_TO_PUBLISH',
        gallery: null,
        submissions: [
          {
            postAt: moment().add(1, 'hour').startOf('hour').toDate()
          }
        ]
      }
    },
    getPost(post) {
      return {
        caption: post.title,
        text: post.description,
        gallery: cloneGallery(post.gallery),
        postAt: moment(post.submissions[0].postAt).toDate()
      }
    },
    syncField(post, field, value, socialAccount) {
      if (field === 'caption') {
        post.title = value
      } else if (field === 'text') {
        post.description = value
      } else if (field === 'gallery') {
        let gallery = cloneDeep(value)
        if (
          gallery &&
          gallery.galleryMediaSet &&
          gallery.galleryMediaSet.length > 0 &&
          gallery.galleryMediaSet[0].media.isVideo
        ) {
          post.gallery = gallery
        }
      } else if (field === 'postAt') {
        post.submissions[0].postAt = value
      } else if (field === 'thread') {
        if (value.length > 0) {
          let text = value[0].text
          if (text) {
            post.title = text
            post.description = text
          }

          let gallery = cloneDeep(value[0].gallery)
          if (gallery) {
            if (
              gallery &&
              gallery.galleryMediaSet &&
              gallery.galleryMediaSet.length > 0 &&
              gallery.galleryMediaSet[0].media.isVideo
            ) {
              post.gallery = gallery
            }
          }
        }
      }
      return post
    }
  }
}
